module.exports = __webpack_public_path__ + "static/media/laptop-one-heart@2x.ef881052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/laptop-one-heart@2x.png
// module id = 1230
// module chunks = 50